import React from "react";
import { GraduationCap, BookOpenCheck, School } from "lucide-react";

const ITEMS = [
  {
    icon: <BookOpenCheck size={20} />,
    title: "Învățământ primar",
    body: "Activități, exemple și metode adaptate claselor primare.",
  },
  {
    icon: <School size={20} />,
    title: "Gimnaziu",
    body: "Instrumente AI aplicabile la majoritatea disciplinelor și activităților școlare.",
  },
  {
    icon: <GraduationCap size={20} />,
    title: "Liceu",
    body: "Utilizare practică AI pentru predare, evaluare și organizarea lecțiilor.",
  },
];

export default function Audience() {
  return (
    <section id="audience" className="py-20 md:py-28 bg-[#EDEEF0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center rounded-full bg-white border border-[#E5E7EB] px-3 py-1 text-xs font-semibold text-[#373A45] uppercase tracking-widest">
            Pentru cine
          </span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold text-[#373A45]">
            Cursul este adaptat pentru cadrele didactice din învățământul preuniversitar.
          </h2>
          <p className="mt-4 text-lg text-[#6B7280] leading-relaxed">
            Exemplele și aplicațiile practice sunt gândite pentru activitatea reală
            la clasă, indiferent de nivelul de predare.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {ITEMS.map((it, i) => (
            <div
              key={i}
              data-testid={`audience-card-${i}`}
              className="bg-white rounded-2xl p-7 border border-[#E5E7EB] hover:border-[#965EA7]/40 hover:shadow-lg transition-all"
            >
              <div className="h-10 w-10 rounded-lg bg-[#3F8EBA] text-white grid place-items-center">
                {it.icon}
              </div>
              <div className="mt-5 font-display text-lg font-semibold text-[#373A45]">{it.title}</div>
              <div className="mt-1 text-sm text-[#6B7280]">{it.body}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
